// extracted by mini-css-extract-plugin
export default {"timeLine":"timeLine_SDafC","body":"body_TI0ar","timeItem":"timeItem__Bwp_","selected":"selected_ecdzL","deleteBtn":"deleteBtn_qu_4T"};